import { gql } from '@apollo/client'

export const INITIAL_DATA_QUERY = gql`
  query InitialData($providerSlug: String) {
    provider(slug: $providerSlug) {
      id
      cateringOptions
      location
      path
      displayTitle
      type
      pricePerHour
      termsAndConditions
      isMeetingpackageProvider
      isInstantBookable
      isDirectPayable
      isFixedBooking
      rating
      includedInRent
      cancellationRules {
        id
        daysToEvent
        percentage
      }
      cities(skipRegions: true) {
        id
        displayName
      }
      parent {
        id
        type
      }
      technicalEquippings {
        id
        name
      }
      address {
        id
        postcode
        street
        streetNumber
      }
      eventCategories {
        id
        name
        isB2c
      }
      pictures {
        url
      }
      room {
        chairsBlock
        chairsGalaBanquet
        chairsParlament
        chairsReception
        chairsRows
        chairsUShape
      }
    }
    currentUser {
      id
      isSignedIn
      isConsultant
      hasAccessToken
      preferredPartner {
        settings {
          hideProjectCrudUi
          isDashboardIntegratedWithNexus
        }
      }
    }
    projects(onlyUpdatable: true, skipEventRooms: true) {
      id
      title
    }
  }
`

export const CREATE_CONTACT_REQUEST_MUTATION = gql`
  mutation CreateContactRequest(
    $providerId: ID!,
    $projectId: ID!,
    $availabilityId: String,
    $proposed: Boolean,
    $consent: Boolean,
    $providerTermsConditionsConsent: Boolean,
    $newsletter: Boolean
    $googleAnalyticsClientId: String,
    $forNewProject: Boolean,
  ) {
    createContactRequest(
      input: {
        providerId: $providerId,
        projectId: $projectId,
        availabilityId: $availabilityId,
        proposed: $proposed,
        consent: $consent,
        providerTermsConditionsConsent: $providerTermsConditionsConsent,
        newsletter: $newsletter
        googleAnalyticsClientId: $googleAnalyticsClientId,
        forNewProject: $forNewProject,
      }
    ) {
      contactRequest {
        id
        ticketNumber
        provider {
          type
          address {
            city {
              name
            }
          }
        }
        project {
          id
          areProjectDetailsUpdated
        }
        eventCategory {
          displayName
        }
      }
      paymentSession {
        id
      }
    }
  }
`

export const CREATE_USER_MUTATION = gql`
  mutation CreateUser($company: String, $email: String!, $name: String!, $phone: String!) {
    createUser(input: {company: $company, email: $email, name: $name, phone: $phone}) {
      user { id }
    }
  }
`

export const CREATE_PROJECT_MUTATION = gql`
  mutation CreateProjectForContactRequest(
    $budgetMax: Int,
    $email: String,
    $eventCategoryId: ID!,
    $guestCount: Int!,
    $providerId: ID!,
    $requestedDates: [ISO8601DateTime!],
    $roomType: String,
    $eventTimeRanges: [EventTimeRangeInput!],
    $cityId: ID,
    $pendingRequest: Boolean,
  ) {
    createProject(input: {
      budgetMax: $budgetMax,
      email: $email,
      eventCategoryId: $eventCategoryId,
      guestCount: $guestCount,
      providerId: $providerId,
      requestedDates: $requestedDates,
      roomType: $roomType,
      eventTimeRanges: $eventTimeRanges,
      cityId: $cityId,
      pendingRequest: $pendingRequest
    }) {
      project {
        id
      }
    }
  }
`

export const UPDATE_PROJECT_OFFER_MUTATION = gql`
  mutation UpdateProjectOffer($ticketNumber: String!, $venueHireCosts: Decimal!, $isGross: Boolean) {
    updateProjectOffer(input: {
      ticketNumber: $ticketNumber,
      venueHireCosts: $venueHireCosts,
      isGross: $isGross,
    }) {
      contactRequest {
        id
      }
    }
  }
`
